
import { Typography} from '@mui/material';


const LexTypography= ({ children,...props }) => {
    return <Typography {...props}>{children}</Typography>
};

export default LexTypography;